<template>
    <div class="flex flex-wrap">
        <div class="w-full md:w-1/2 mt-6 px-2">
            <banner-entity-selector v-model="path.entity" :enabled="enabled" />
        </div>
        <div
            class="w-full md:w-1/2 mt-6 px-2"
            :class="path.entity === itemsCurrent.entity ? '' : 'border-warning'"
        >
            <products-search
                v-if="path.entity === 'products'"
                v-model="product"
                paginated
                label="Producto"
                :default-filters="$data.$defaultFilters"
                :enabled="enabled"
                @input="onSelectProduct"
            />
            <collections-search
                v-else-if="path.entity === 'collections'"
                v-model="collection"
                label="Colección"
                :default-filters="$data.$defaultFilters"
                @input="onSelectCollection"
            />
            <brands-search
                v-else-if="path.entity === 'brands'"
                v-model="brand"
                label="Marca"
                :enabled="enabled"
                :default-filters="$data.$defaultFilters"
                @input="onSelectBrand"
            />
            <lines-search
                v-else-if="path.entity === 'lines'"
                v-model="line"
                label="Categoría/Subcategoría"
                :enabled="enabled"
                :default-filters="$data.$defaultFilters"
                @input="onSelectLine"
            />
            <custom-input
                v-else-if="path.entity === 'custom'"
                v-model="custom"
                autocomplete="off"
                type="text"
                name="line-name"
                label="Escribe el path"
                placeholder="/products"
                class="w-full"
                :disabled="!enabled"
                @blur="onChangeCustom"
            />
        </div>
    </div>
</template>

<script>
import BannerEntitySelector from "@/components/banners/BannerEntitySelector.vue";
import CustomInput from "@/components/utils/CustomInput.vue";

export default {
    name: "PathManage",
    components: {
        BannerEntitySelector,
        CustomInput,
        ProductsSearch: () =>
            import("@/components/products/ProductsSearch.vue"),
        CollectionsSearch: () =>
            import("@/components/collections/CollectionsSearch.vue"),
        BrandsSearch: () => import("@/components/brands/BrandsSearch.vue"),
        LinesSearch: () => import("@/components/lines/LinesSearch.vue")
    },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            type: Object,
            default: () => ({
                entity: "line",
                name: "",
                slug: ""
            }),
            required: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        $defaultFilters: { active: true },
        path: {
            entity: "undefined",
            name: "",
            slug: ""
        },
        product: { name: "", slug: "", id: "" },
        brand: { name: "", slug: "" },
        collection: { name: "", slug: "" },
        line: { name: "", slug: "" },
        custom: ""
    }),
    watch: {
        itemsCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemsCurrent);
    },
    methods: {
        onSelectProduct(item) {
            const aux = {
                entity: "products",
                id: String(item.id),
                slug: item.slug,
                name: item.name
            };
            this.$emit("change", aux);
        },
        onSelectLine(item) {
            const aux = {
                entity: "lines",
                slug: item.slug,
                name: item.name
            };
            this.$emit("change", aux);
        },
        onSelectCollection(item) {
            const aux = {
                entity: "collections",
                slug: item.slug,
                name: item.name
            };
            this.$emit("change", aux);
        },
        onSelectBrand(item) {
            const aux = {
                entity: "brands",
                slug: item.slug,
                name: item.name
            };
            this.$emit("change", aux);
        },
        onChangeCustom() {
            const aux = {
                entity: "custom",
                slug: this.custom,
                name: this.custom
            };
            this.$emit("change", aux);
        },
        setInput(value) {
            this.path = value;
            if (value.entity === "lines") {
                this.line = {
                    name: value.name,
                    slug: value.slug
                };
            } else if (value.entity === "brands") {
                this.brand = {
                    name: value.name,
                    slug: value.slug
                };
            } else if (value.entity === "products") {
                this.product = {
                    id: value.id,
                    name: value.name,
                    slug: value.slug
                };
            } else if (value.entity === "collections") {
                this.collection = {
                    name: value.name,
                    slug: value.slug
                };
            } else if (value.entity === "custom") {
                this.custom = value.slug;
            }
        }
    }
};
</script>
